// cookie政策管理
import http from "@/jslibs/axios/http";

// cookie政策更新
export const edit = (data) => http.post("/v1/cms/CookiePolicy", data);

// cookie政策详情
export const detail = (data) => http.get("/v1/cms/CookiePolicy", data);
